import { useStores } from '../../../../app/root/domain/stores/useStores';

export function useForgotPasswordStore() {
	const { forgotPasswordStore } = useStores();

	return forgotPasswordStore;
}
